import {inject, Injectable} from "@angular/core";
import {ReportApiService} from "../generated-sources/api/report";
import {Observable} from "rxjs";
import {DocumentMetadata} from "../../shared/model/document-metadata";

@Injectable({
    providedIn: "root"
})
export class ReportService {

    private readonly reportApiService = inject(ReportApiService);

    constructor() {
    }

    getProjectReport(projectName: string, dealIds: number[], projectClosingDate?: string, firstRoundOffersDeadline?: string): Observable<Blob> {
        return this.reportApiService.getProjectReport(projectName, dealIds, projectClosingDate, firstRoundOffersDeadline);
    }

    getAllProjectReports(): Observable<DocumentMetadata[]> {
        return this.reportApiService.getAllProjectReports() as unknown as Observable<DocumentMetadata[]>; // TODO update model in contract and backend (planned in #23299)
    }
}
